import { initialState } from "../finance.slice";

const resetMoneyTransaction = () => {
    return initialState;
}

export default resetMoneyTransaction;